export default {
  INIT: 'init',
  DOWNLOADED: 'downloaded',
  DELETED: 'deleted',
  UPDATED: 'updated',
  ERROR: 'error'
};
